import { createContext } from "react";
const MobileContext = createContext<boolean>(false);

export default MobileContext;